
import { computed, defineComponent } from "vue";
import { useStore } from "../store";

export default defineComponent({
  name: "Home",
  components: {},
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => store.getters.isUserLoggedIn);

    return {
      isLoggedIn,
    };
  },
});
